import React, { useState } from 'react'
import _ from 'lodash';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import TaxCategoryComponent from '../components/tax-category.component';
import { taxCategories } from '../../../../../../redux/tax-categories/action';

const ManagementTaxCategory = () => {  
  const navigate = useNavigate()
  const dispatch = useAppDispatch()

const [
    chosenTaxCategory,
    setChosenTaxCategory
  ] = useState<any>({})


  const handleInnerFormChange: any = (event: any, field: string) => {
    setChosenTaxCategory({ ...chosenTaxCategory, [field]: event });
  }
  
 
  
const handleFormSubmit  = async (event: any) => {
    event.preventDefault();
 
        dispatch(taxCategories.create({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v2.0/beta/Taxes`,entity:'taxCategories',jsonData:{ 
            ...chosenTaxCategory
    }})).then(()=>{
        back()
      })
     
  }
 
const back=()=>{
  navigate('/management/configuration/payment-management/tax-categories')
} 

    return (
        <>

          <TaxCategoryComponent 
          handleInnerFormChange={handleInnerFormChange}
          chosenTaxCategory={chosenTaxCategory}
          back={back}
          handleFormSubmit={handleFormSubmit}
          /> 
    
          </>
    )
    
    }
   
    export default ManagementTaxCategory;